module.exports = __webpack_public_path__ + "img/nav-design-classic@2x.a59dfe2.jpg";